<template>
  <el-container class="root_container">
    <el-header style="height: auto;z-index:1000;"><vHead></vHead></el-header>
    <!-- <el-main style="min-width:1190px"><vSearch></vSearch></el-main> -->
    <keep-alive>
      <el-header
        style="height:100px;"
        v-if="
          $store.state.webInfo.base_conf.is_nav == 1 ||
            $store.state.webInfo.base_conf.is_home_search == 1
        "
        ><vNav></vNav
      ></el-header>
    </keep-alive>
    <el-main
      class="tt"
      style="min-width:1190px; padding:0px; min-height:800px !important;"
    >
      <router-view></router-view>
    </el-main>

    <el-footer
      style=" background: #ffffff;height:auto;padding:0;border-top:solid 1px #e5e5e5;"
      ><vFooter></vFooter
    ></el-footer>
  </el-container>
</template>

<script>
import vHead from "@/common/header";
import vSearch from "@/common/search";
import vNav from "@/common/nav";
import vFooter from "@/common/footer";

export default {
  name: "Home",
  components: {
    vHead,
    vSearch,
    vFooter,
    vNav
  },
  created() {
    console.log(this.$route.name);
  }
};
</script>

<style lang="less" scoped>
.tt {
  min-height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue